import * as React from 'react';
import ReactHotToast from 'react-hot-toast';

import { Text } from '@/components/Atoms/Text/Text';
import { ConfirmModal } from '@/components/ConfirmModal/ConfirmModal';
import { useUpdateRSSPriority } from '@/features/Connect/hooks/useUpdateRSSPriority';
import type { FetchRssSource, Priority } from '@/types';
import { ErrorToast } from '@/utils/toasts';

export const BulkPriorityUpdateModal = ({
  showModal,
  rssSources,
  onDismiss,
  selectedPriority,
}: BulkPriorityUpdateModalType) => {
  const [bulkPriorityUpdateLoading, setBulkPriorityUpdateLoading] =
    React.useState(false);

  const editRss = useUpdateRSSPriority();

  const modalHeading = 'Prirority Change';

  const bulkPriorityUpdateHandler = async () => {
    try {
      setBulkPriorityUpdateLoading(true);
      await Promise.all(
        rssSources.map((rssSource) =>
          editRss.mutateAsync({
            source_id: rssSource.source_id,
            priority: selectedPriority,
          })
        )
      );
      ReactHotToast.success('Priority updated successfully.');
      onDismiss();
    } catch {
      ErrorToast(
        'Failed to update priority for the selected sources. Please try again later.'
      );
    } finally {
      setBulkPriorityUpdateLoading(false);
    }
  };

  return (
    <ConfirmModal
      closeOnOutsideClick={false}
      onDismiss={onDismiss}
      modalHeading={modalHeading}
      modalContent={
        <Text>
          Are you sure you want to change the priority of{' '}
          <b>{rssSources.length}</b> sources to <b>{selectedPriority}</b>?
        </Text>
      }
      showModal={showModal}
      primaryButtonText='Yes, Update'
      secondaryButtonText='Cancel'
      onSecondarySubmit={onDismiss}
      onPrimarySubmit={bulkPriorityUpdateHandler}
      primaryLoading={bulkPriorityUpdateLoading}
    />
  );
};

type BulkPriorityUpdateModalType = {
  onDismiss: () => void;
  showModal: boolean;
  rssSources: FetchRssSource[];
  selectedPriority: Priority;
};
